module.exports = __webpack_public_path__ + "static/img/call-pass-off.92f64709.png";